export default function productVariantSelector() {
	const productVariant = document.getElementById('productVariantSelector');

	if (productVariant) {
		productVariant.onchange = event => {
			window.location.href = event.target.value;
		};
	}
}
